/* eslint-disable */
import { endpoints } from '@/Constants';
import { authHeader } from '@/Helpers';
import handleResponse from './helpers';

function fetchEligibleItems(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints?.CONVERSION_ELIGIBLE_ITEMS, requestOptions).then(handleResponse);
}

function createConversionWorkOrder(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints?.CONVERSION_WORKORDER, requestOptions).then(handleResponse);
}

const conversionServices = {
	fetchEligibleItems,
	createConversionWorkOrder,
};

export default conversionServices;
